//Misc
export const LOADING = "LOADING";

//User
export const RECEIVE_USER = "RECEIVE_USER";
export const IS_LOGGED_IN = "IS_LOGGED_IN";
export const IS_SGZ_SUBSCRIBED = "IS_SGZ_SUBSCRIBED";

//Settings
export const RECEIVE_SETTINGS = "RECEIVE_SETTINGS";
